import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AppsettingsService } from '../services/appsettings/appsettings.service';
import { DashboardsSubMenuUrl } from '../enums/dashboards-submenu.enum';
import { MenuPoint } from '@agilox/ui-common';
import { BoardConfig } from '../../interfaces/board-config.interface';
import { AppSettings } from '../../interfaces/app-settings.interface';

export const boardNavigationResolver: ResolveFn<MenuPoint[]> = (): Observable<MenuPoint[]> => {
	const appSettingsService = inject(AppsettingsService);

	return appSettingsService.getUserAppSettings().pipe(
		filter((settings): settings is AppSettings => !!settings),
		take(1),
		map((appSettings) => {
			const boards: BoardConfig[] = appSettings.boards || [];

			const dynamicMenus: MenuPoint[] = boards.map((board) => ({
				name: board.name,
				url: `${DashboardsSubMenuUrl[board.type]}/${board.id}`,
				roles: [],
			}));
			return dynamicMenus;
		})
	);
};
